

const AUTH_USER_SUCCESS = (state,payload) =>{
    
    if(payload){
        state.action  = payload.action   
    }
  
}


const AUTH_USER_STATE = (state) =>{
    
    state.payload = {}
    state.action = ""
  
}
  
export default {
    AUTH_USER_SUCCESS, 
    AUTH_USER_STATE,
}